import { render, staticRenderFns } from "./RoundReceiveTable.vue?vue&type=template&id=1fc4e01b&scoped=true&"
import script from "./RoundReceiveTable.vue?vue&type=script&lang=js&"
export * from "./RoundReceiveTable.vue?vue&type=script&lang=js&"
import style0 from "./RoundReceiveTable.vue?vue&type=style&index=0&id=1fc4e01b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4e01b",
  null
  
)

export default component.exports